import { Period } from '@spike/model';
import {
    BOOKING_ATTEMPTS_ERROR_ACTION_TYPE,
    BOOKING_ATTEMPTS_FETCH_START_ACTION_TYPE,
    BOOKING_ATTEMPTS_FETCH_SUCCESS_ACTION_TYPE,
    BOOKING_ATTEMPTS_METRICS_FETCH_START_ACTION_TYPE,
    BOOKING_ATTEMPTS_METRICS_FETCH_SUCCESS_ACTION_TYPE,
    BOOKING_ATTEMPTS_RESET_ACTION_TYPE,
    BookingAttemptsAction
} from 'actions/bookingAttempts/BookingAttemptsActionsTypes';
import {
    convertToBookingAttempt,
    convertToBookingAttemptMetrics
} from 'actions/bookingAttempts/BookingAttemptsConverter';
import {
    FetchBookingAttemptsMetricsResponseDto,
    FetchBookingAttemptsResponseDto
} from 'actions/bookingAttempts/BookingAttemptsDto';
import ApiClient from 'api';
import { createTokenConfig } from 'api/ApiClient';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';

const resourceUrl = '/booking_attempts';
const searchUrl = `${resourceUrl}/search`;
const metricsUrl = `${resourceUrl}/metrics`;

export const reset = (): BookingAttemptsAction => ({ type: BOOKING_ATTEMPTS_RESET_ACTION_TYPE });

export const error = (): BookingAttemptsAction => ({ type: BOOKING_ATTEMPTS_ERROR_ACTION_TYPE });

export const fetchBookingAttemptsThunk = (
    page = 1,
    size = 10,
    type = 'abandoned',
    query?: string,
    statuses?: Array<string>,
    clientTypes?: Array<string>,
    datePeriod?: Period
): ThunkAction<void, RootState, unknown, BookingAttemptsAction> => {
    return async (dispatch, getState) => {
        dispatch({ type: BOOKING_ATTEMPTS_FETCH_START_ACTION_TYPE });

        const {
            login,
            marketplace: { marketplace }
        } = getState();

        try {
            const { data: response } = await ApiClient.get<FetchBookingAttemptsResponseDto>(searchUrl, {
                ...createTokenConfig(String(login.auth.token)),
                params: {
                    page,
                    size,
                    view_type: type,
                    status: statuses,
                    client_types: clientTypes,
                    marketplace_id: marketplace?.id,

                    ...(datePeriod && {
                        start_date: datePeriod.from.format('YYYY-MM-DD'),
                        end_date: datePeriod.to.format('YYYY-MM-DD')
                    }),

                    ...(query && { query })
                }
            });

            dispatch({
                type: BOOKING_ATTEMPTS_FETCH_SUCCESS_ACTION_TYPE,
                payload: {
                    bookingAttempts: response.data.map(dto =>
                        convertToBookingAttempt(dto, marketplace?.schedule.timeZone)
                    ),
                    pagination: {
                        page: response.page,
                        size: response.size,
                        totalPages: response.total_pages,
                        totalRecords: response.total_records
                    }
                }
            });
        } catch (error) {
            dispatch({ type: BOOKING_ATTEMPTS_ERROR_ACTION_TYPE });
        }
    };
};

export const fetchBookingAttemptsMetricsThunk = (
    query?: string,
    clientTypes?: Array<string>,
    datePeriod?: Period
): ThunkAction<void, RootState, unknown, BookingAttemptsAction> => {
    return async (dispatch, getState) => {
        dispatch({ type: BOOKING_ATTEMPTS_METRICS_FETCH_START_ACTION_TYPE });

        const {
            login,
            marketplace: { marketplace }
        } = getState();

        try {
            const { data: response } = await ApiClient.get<FetchBookingAttemptsMetricsResponseDto>(metricsUrl, {
                ...createTokenConfig(String(login.auth.token)),
                params: {
                    client_types: clientTypes,
                    marketplace_id: marketplace?.id,

                    ...(datePeriod && {
                        start_date: datePeriod.from.format('YYYY-MM-DD'),
                        end_date: datePeriod.to.format('YYYY-MM-DD')
                    }),

                    ...(query && { query })
                }
            });

            dispatch({
                type: BOOKING_ATTEMPTS_METRICS_FETCH_SUCCESS_ACTION_TYPE,
                payload: {
                    metrics: convertToBookingAttemptMetrics(response.metrics)
                }
            });
        } catch (error) {
            dispatch({ type: BOOKING_ATTEMPTS_ERROR_ACTION_TYPE });
        }
    };
};
